import React from 'react';
import { useDeepCompareEffect } from 'react-use';
import { useDispatch } from 'react-redux';
import { useTranslate, useLocalizedDataSelector } from '@hooks';
import { fetchCountries } from '@actions';
import { toNumberArray } from '@dotone/react-ui-core/utils';
import { FilterBlock } from '@dotone/react-ui-core';

const CountryFilterBlock = ({ ids = [], ...otherProps }) => {
  const { locale, t } = useTranslate('common', 'model');
  const dispatch = useDispatch();
  const countries = useLocalizedDataSelector(({ countryList }) => countryList);

  useDeepCompareEffect(() => {
    if (ids && !countries.length) {
      dispatch(fetchCountries(locale));
    }
  }, [dispatch, locale, ids, countries.length]);

  const filter = (items, countryIds = []) => {
    return items.filter((item) => toNumberArray(countryIds).indexOf(item.id) > -1);
  };

  return <FilterBlock label={t('country')} items={filter(countries, ids)} {...otherProps} />;
};

export default React.memo(CountryFilterBlock);
